import { useMode } from "@/lib/mode";

export default function ModeSwitch() {
  const [mode, setMode] = useMode();
  const opt = (k, label, emoji) => (
    <button onClick={() => setMode(k)} data-testid={`mode-${k}`} aria-pressed={mode === k}
      className={`h-8 px-2.5 sm:px-3 rounded-full text-xs font-semibold inline-flex items-center gap-1 transition-colors ${mode === k ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>
      <span aria-hidden>{emoji}</span><span className={mode === k ? "" : "hidden sm:inline"}>{label}</span>
    </button>
  );
  return (
    <div className="inline-flex p-0.5 rounded-full bg-secondary" data-testid="mode-switch">
      {opt("salon", "Salon", "🎪")}
      {opt("atelier", "Gestion", "💼")}
    </div>
  );
}
